import * as stylex from '@stylexjs/stylex'
import { type ElementType } from 'react'
import { Box, type BoxProps } from '../Box/Box'

const baseStyles = stylex.create({
  root: {
    display: 'none',
  },
})

export type HiddenProps<RootComponent extends ElementType = 'div', BoxElement extends HTMLElement = HTMLDivElement> = {
  /** 是否隱藏元素（設為 display: none） */
  hidden?: boolean
} & BoxProps<RootComponent, BoxElement>

/**
 * Hidden 是條件式隱藏元件，可透過 hidden prop 控制 display: none。
 * 繼承 Box 的所有 ExtendStyleProps。
 */
export function Hidden<RootComponent extends ElementType = 'div', BoxElement extends HTMLElement = HTMLDivElement>(props: HiddenProps<RootComponent, BoxElement>) {
  const { component = 'div', rootStyle, hidden, ...rest } = props
  return (
    <Box
      component={component}
      rootStyle={[
        hidden && baseStyles.root,
        rootStyle,
      ]}
      {...rest}
    />
  )
}
